import React, {Fragment} from 'react';
import {Dialog} from '@mui/material';

import {IFrameModal} from 'presentation/components';
import {useHostName} from 'presentation/hooks';
import Icon from 'presentation/icons';
import {useTeaForm} from 'presentation/modules/booking/shared/hooks/useTeaForm';
import {useMediaQueries} from 'presentation/pages/private/hooks/useMediaQueries';
import {translations} from 'presentation/translations-new';
import {ChatsModalContent} from './components/ChatsModalContent';
import {StyledCloseButton, StyledDialogHeader, StyledDialogTitle} from './styles';
import {ChatsModalProps} from './types';

const {modal} = translations['pt-br'].privateFlow.help.contactUs;
const {close, goBack} = translations['pt-br'].commons;
const {iFrameTitle: teaIframeTitle} =
	translations['pt-br'].privateFlow.bookingFlow.specialtyFlow.teaFlow;
const DIALOG_TITLE_ID = 'help-chats';

export function ChatsModal({open, onClose}: ChatsModalProps) {
	const {isMobile} = useMediaQueries();
	const {isGndiSaoPaulo} = useHostName();
	const {getTeaFormUrl, IS_FETCHING, openIFrame, handleCloseIframe, embeddedLink} = useTeaForm();

	return (
		<Fragment>
			<Dialog
				fullScreen={isMobile}
				open={open}
				onClose={onClose}
				aria-labelledby={DIALOG_TITLE_ID}>
				<StyledDialogHeader>
					<StyledDialogTitle id={DIALOG_TITLE_ID} component="h2">
						{modal.title}
					</StyledDialogTitle>
					<StyledCloseButton aria-label={isMobile ? goBack : close} onClick={onClose}>
						<Icon name={isMobile ? 'arrow-back' : 'close-filled'} />
					</StyledCloseButton>
				</StyledDialogHeader>

				<ChatsModalContent
					teaFormProps={{handleGoToTeaForm: getTeaFormUrl, isFetching: IS_FETCHING}}
				/>
			</Dialog>

			{isGndiSaoPaulo ? (
				<IFrameModal
					openIframe={openIFrame}
					setOpenIframe={handleCloseIframe}
					title={teaIframeTitle}
					url={embeddedLink}
				/>
			) : null}
		</Fragment>
	);
}
